import React from "react";

const CreditCardIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 8V6C0 4.896 0.896 4 2 4H22C23.104 4 24 4.896 24 6V8H0ZM24 11V18C24 19.104 23.104 20 22 20H2C0.896 20 0 19.104 0 18V11H24ZM9 16H3V17H9V16ZM12 14H3V15H12V14ZM21 14H18V15H21V14Z" fill="#707070" />
    </svg>
);

export default CreditCardIcon;